<template>
  <div>

    <b-card header="CONTROLE DE TROCO">
       <b-row>
        <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">Praças</h4>
          <div class="small text-muted">&nbsp;</div>
          <div class="small text-muted">&nbsp;</div>
        </b-col>
        <b-col sm="7" class="">
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
              <b-button type="button" @click="refreshUnit()" variant="primary" class="float-right"><i class="icon-refresh"></i></b-button>
              <span style="width:10px"></span>
              <b-button type="button" @click="$bvModal.show('help_unitcomp')" variant="primary" class="float-right"><i class="icon-info"></i></b-button>
          </b-button-toolbar>
          
          </b-col>
      </b-row>

    <b-row>
      <b-col sm="6" lg="3" v-for="item in units" :key="item.id">
        <b-card no-body :class="colorClass(item.originId)" @click="selectUnit(item)">
          <b-card-body class="pb-0">
            
            <b-dropdown class="float-right" variant="transparent p-0" right>
              <template slot="button-content">
                <i class="icon-settings"></i>
              </template>
              <b-dropdown-item :to="{ path: '/changereturn' }">Alterar Responsável</b-dropdown-item>
            </b-dropdown>
            
            <p>{{ item.originId }}</p>
            <h3 class="mb-0">{{ item.description }}</h3>
            <h5 class="mb-0">{{ item.code }}</h5>
            <p>&nbsp;</p>
            <p v-if="item.supervisorCode">Responsável: [{{ item.supervisorCode }}] {{ item.supervisorName }}</p>
            <p></p>

            
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>


      <div slot="footer">
        <b-row class="text-center">
          
        </b-row>
      </div>

    </b-card>

    <div>
      <b-modal id="help_unitcomp" title="Ajuda" ok-only size="lg"
      ok-title="Fechar">
          <h3>Controle de Troco</h3>
          <h4>Praças</h4>
          <p class="my-4">
              O Controle de Troco é realizado por Praça. Selecione a praça desejada para continuar.<br>
              Será necessário entrar com o nome e senha do usuário.<br>
              Caso nenhuma Praça seja exibida, verifique a conexão com o Servidor e clique em Atualizar
          </p>
          <p class="my-4">
            Servidor: {{ this.$store.state.ws_url }}
          </p>

          <p><a @click="initializeData()">Inicializar dados</a></p>
          
      </b-modal>
    </div>

 <div>
        <b-modal
        id="modal-login"
        ref="modal"
        title="Usuário"
        @show="loginReset"
        @hidden="loginReset"
        @ok="loginHandleOk"
        ok-title="OK"
        cancel-title="Cancelar"
        >
        <form ref="form" @submit.stop.prevent="loginHandleSubmit">
            <b-form-group
            label="Usuário"
            label-for="name-input"
            TODO_invalid-feedback="Nome obrigatório."
            :state="loginState"
            >
            <b-form-input
                id="name-input"
                v-model="selectedUser.username"
                :state="loginState"
                required
            ></b-form-input>            
            
            </b-form-group>

             <b-form-group
            label="Senha"
            label-for="password-input"
            TODO_invalid-feedback="Senha obrigtória."
            :state="loginState"
            >
            <b-form-input
                id="password-input"
                type="password"
                v-model="selectedUser.password"
                :state="loginState"
                required
            ></b-form-input>            
            <div class="invalid-feedback">
                {{ selectedUser.message  }}
            </div>
            </b-form-group>

        </form>
        </b-modal>
    </div>


  </div>

  
</template>

<script>
import axios from "axios";

export default {
  name: "ChangeControlUnitComponent",
  props: {
    controlType: Number
  },
  data() {
    return {
        units: [],
        timer: '',
        loginState: null,
        selectedUser: { username: "", password: "", message: "Usuário ou senha inválidos. Verifique e tente novamente."},
        checkUser: { },
        selectedUnit: {},
        type: this.controlType ? this.controlType : 1,
    }
  },
  methods: {
      colorClass(value) {
          const classArray = [ "bg-primary", "bg-danger", "bg-success", "bg-warning" ];
          return classArray[ (value % classArray.length ) ];

        },
        variant(value) {
            let $variant
            if (value <= 25) {
                $variant = 'info'
            } else if (value > 25 && value <= 50) {
                $variant = 'success'
            } else if (value > 50 && value <= 75) {
                $variant = 'warning'
            } else if (value > 75 && value <= 100) {
                $variant = 'danger'
            }
            return $variant
        },
        selectUnit(value) {
          //console.log("Usuario: '" + this.$store.state.currentUser.id + "'")

          if(!this.$store.state.currentUser.id > 0) {
            this.selectedUnit = value
            //console.log("Selecionando usuário")
            //console.log(this.selectedUnit)            
            this.$bvModal.show('modal-login')
          }
          else {
            this.$store.commit('SET_CURRENT_UNIT', value)
            // Tipo de controle 2 - Vai para a tela principal do controle de troco
            if(this.type == 2)
              this.$router.push({ path: '/changecontrol/changecontrol' })
          }
            
        },

        refreshUnit() {
          //this.getWebServer();
          this.getUnit();
        },

        async getUnit() {
            try {
                if(this.$store.state.ws_url != null && this.$store.state.ws_url != "") {
                  const units = await axios.get(
                      this.$store.state.ws_url + "/sgap/unit"
                  );
                  this.units = units.data;
                  if(this.units.length > 0) {
                    this.cancelAutoUpdate();
                  }
                  //console.log("Unidades atualizadas: " + this.units.length)
                }
                else {
                  this.timer = setInterval(this.getUnit, 1000);
                }
            } catch (e) {
                console.log(e);                
                this.timer = setInterval(this.getUnit, 1000);
            }
        },

        cancelAutoUpdate () {
            clearInterval(this.timer);
        },

        async getWebServer() {
          try {

            var url = window.location.origin + "/SGAPSaWeb/service/sicat/sgapws"
            url = this.url = this.$store.state.ws_url + '/changecontrol/wsurl'
            console.log(url)

            const wsdata = await axios.get(
              url
            );
            //console.log("URL Preferências: ")
            //console.log(wsdata.data.ws_url)
            this.$store.commit('SET_WS_URL', wsdata.data.ws_url)
          }
          catch(e) {
            console.log(e);
          }
        },

        async initializeData() {
          try {
            const wsdata = await axios.get(
              this.$store.state.ws_url + "/changecontrol/initialize"
            );
            console.log("Dados inicializados")
            //console.log(wsdata.data.ws_url)            
          }
          catch(e) {
            console.log(e);
          }
        },

        async getUser(user, password) {
          try {
                const users = await axios.get(
                    this.$store.state.ws_url + "/sgap/operator?code=" + user + "&password=" + password
                );
                this.$store.commit('SET_CURRENT_USER', users.data)
                this.$store.commit('SET_CURRENT_UNIT', this.selectedUnit )
                //console.log(user.data)
                if(this.type==2)
                  this.$router.push({ path: '/changecontrol/changecontrol' })
            } catch (e) {
                console.log(e)                 
            }
        },

        loginCheckValidity() {
            //const valid = this.$refs.form.checkValidity()
            let valid = false

            //console.log("Usuário: " + this.selectedUser.password + " - " + this.selectedUser.password.trim().length)

            if(this.selectedUser.username.trim().length > 0 && this.selectedUser.username.trim().length > 0) {
              this.getUser(this.selectedUser.username, this.selectedUser.password);
              this.valid = true
            }
            else {
              this.selectedUser.message = 'Preencha os campos de Usuário e Senha e tente novamente.';
            }
            this.loginState = valid            
            return valid
        },
        loginReset() {
            this.selectedUser.username = ''
            this.selectedUser.password = ''
            this.loginState = null
        },
        loginHandleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            this.loginHandleSubmit()
        },
        loginHandleSubmit() {
            // Exit when the form isn't valid
            if (!this.loginCheckValidity()) {
              return
            }
            // Push the name to submitted names
            //console.log(this.$store.state.selectedUser)
            // Hide the modal manually
            console.log("passou por aqui")
            this.$nextTick(() => {
              this.$bvModal.hide('modal-login')
              if(this.type==2)
                this.$router.push({ path: '/changecontrol/changecontrol' })
            })
        },
  },
  mounted: function() {

      this.getWebServer();
      this.getUnit()
        
  }
};
</script>
